import { render, staticRenderFns } from "./modal_show_award.vue?vue&type=template&id=75bfe9c6&scoped=true"
import script from "./modal_show_award.vue?vue&type=script&lang=js"
export * from "./modal_show_award.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bfe9c6",
  null
  
)

export default component.exports